import React from "react";
import ShopArea from "../../components/ShopAreas/ShopArea";
import { Link } from "react-router-dom";

const ServicesArea = () => {
  return (
    <section className="services-area-five">
      <div className="container">
        
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="section-title-three text-center mb-60">
              <span className="sub-title">Our Products</span>
              <h2 className="title">Discover Our Finest Products</h2>
              <p>
                Explore our exquisite selection of home textile essentials meticulously designed to elevate your living spaces.
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <ShopArea layout="home" />
        </div>


        <Link to="explore-products/all" style={{ display: "block", textAlign: "center", textDecoration: "underline" }}>View all Products</Link>


      </div>
    </section>
  );
};

export default ServicesArea;
